import { render, staticRenderFns } from "./studentRankTable.vue?vue&type=template&id=5dec070f&scoped=true"
import script from "./studentRankTable.vue?vue&type=script&lang=js"
export * from "./studentRankTable.vue?vue&type=script&lang=js"
import style0 from "./studentRankTable.vue?vue&type=style&index=0&id=5dec070f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec070f",
  null
  
)

export default component.exports